import React from "react";
import WarningMessage from "./WarningMessage";
import { useState } from "react";

export default ({ show, text }) => {
	const [hidden, setHidden] = useState(false);

	return <WarningMessage show={!hidden && show} text={text} onClickClose={() => setHidden(true)} />;
};
